import { socialChannelIconPath, socialTypeIconPath } from '../../lib/assets'
import {
  catalogTypeIdFromKey,
  INSTAGRAM_GRAPH_DESCRIPTION,
} from '../../lib/utils/socialNetworkCatalog'

export const COMPETITOR_CHANNEL_TYPES = [
  { key: INSTAGRAM_GRAPH_DESCRIPTION, label: 'Instagram', icon: socialTypeIconPath('instagram_graph') },
  { key: 'facebook', label: 'Facebook', icon: socialTypeIconPath('facebook') },
  { key: 'twitter', label: 'X (Twitter)', icon: socialTypeIconPath('twitter') },
  { key: 'linkedin', label: 'LinkedIn', icon: socialChannelIconPath('linkedin') },
]

export function getCompetitorChannelMeta(channelKey) {
  const normalizedKey = channelKey === 'instagram' ? INSTAGRAM_GRAPH_DESCRIPTION : channelKey
  return (
    COMPETITOR_CHANNEL_TYPES.find((c) => c.key === normalizedKey)
    || COMPETITOR_CHANNEL_TYPES.find((c) => c.key === channelKey)
    || null
  )
}

export function getCompetitorChannelTypeId(channelKey, socialNetworkTypes = []) {
  return catalogTypeIdFromKey(socialNetworkTypes, channelKey)
}
